// @flow
import Route from 'react-router-dom/Route';
import Switch from 'react-router-dom/Switch';

import BuyingDiamondsMenu from '@src/components/menus/BuyingDiamondsMenu';
import DiamondEducationMenu from '@src/components/menus/DiamondEducationMenu';
import CustomerServiceMenu from '@src/components/menus/CustomerServiceMenu';
import JewelryEducationMenu from '@src/components/menus/JewelryEducationMenu';

export default (
  <Switch>
    <Route path='/buying-diamonds' component={BuyingDiamondsMenu} />
    <Route path='/form_responders' component={BuyingDiamondsMenu} />
    <Route path='/diamond-education' component={DiamondEducationMenu} />
    <Route path='/customer-service' component={CustomerServiceMenu} />
    <Route path='/jewelry-education' component={JewelryEducationMenu} />
  </Switch>
);
